import {
  GET_CURRENT_USER_SUCCESS,
  LOGIN_SUCCESS,
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  SIGN_OUT_USER_SUCCESS,
  SET_CURRENT_USER_RESULT,
} from '../types/authenticate';

const initState = {
  data: {},
  isRefreshToken: false,
  user: {},
  isLogin: false,
  isLoading: true,
};

const reducer = (state = initState, action) => {
  const { type } = action;
  switch (type) {
    case SET_CURRENT_USER_RESULT:
    case LOGIN_SUCCESS:
    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        user: action.payload || {},
        isLoading: false,
        isLogin: !!action.payload?.username,
      };
    case REFRESH_TOKEN:
      return { ...state, isRefreshToken: true };
    case REFRESH_TOKEN_SUCCESS:
      return { ...state, isRefreshToken: false };
    case SIGN_OUT_USER_SUCCESS:
      return { ...state, user: {}, isLogin: false };
    default:
      return state;
  }
};

export default reducer;
